import React from "react";
import { Card, makeStyles } from "@material-ui/core";
import ReactECharts from "echarts-for-react";
import { getRandomColor } from "../../../Utilities/Functions";
import styles from "./styles";

const useStyles = makeStyles(styles);

const StackedBar = (props) => {
  const classes = useStyles();

  const { title, series, categories } = props;

  const legendData = (series || []).map((item) => item["name"]);

  const _series = (series || []).map((item) => ({
    name: item["name"],
    type: "bar",
    stack: "total",
    label: {
      show: true,
      formatter: item.labelFormatter,
    },
    emphasis: {
      focus: "series",
    },
    data: item["data"],
    itemStyle: item["color"] ? { color: item["color"] } : {},
  }));

  const options = {
    title: {
      text: title,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      top: "bottom",
      data: legendData,
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "10%",
      containLabel: true,
    },
    xAxis: {
      type: "value",
    },
    yAxis: {
      type: "category",
      data: categories,
    },
    series: _series,
  };

  return (
    <Card className={classes.container} variant="outlined" elevation={0}>
      <ReactECharts option={options} />
    </Card>
  );
};

export default StackedBar;
